<template>
  <!--<div id="landing-page"  src='../assets/img/background_bike_preview.jpg' class="is-marginless is-paddingless">-->
  <progressive-background @onLoad="onLoadBackgroundImage" no-ratio :src="backgroundImage" :placeholder="backgroundImagePreview">
    <div class="is-overlay is-landing" :class="{'is-invisible': isInvisible}" v-bind:style='{"opacity":(isFocused ? "0.6" : "0.3")}'></div>

    <vue-particles color="#dedede"></vue-particles>

    <section class="hero is-fullheight" >
      <!-- Hero Body -->
      <div class="hero-body">
        <landing-body></landing-body>
      </div>
      <!-- Hero Footer -->
      <div class="hero-foot">
        <nav-footer></nav-footer>
      </div>
      <cookie-law theme="giada" buttonText="Got it!">
        <div slot="message">
          We use cookies to ensure you get the best experience.  <router-link to="privacy">Learn more</router-link>
        </div>
      </cookie-law>
    </section>
  </progressive-background>
  <!--</div>-->

</template>

<script>
import NavFooter from './general/NavFooter'
import LandingBody from './landingPage/LandingBody'
import TermsPage from './TermsPage'
import PrivacyPage from './PrivacyPage'
import CookieLaw from 'vue-cookie-law'

import {bus} from '../main'

export default {
  name: 'LandingPage',
  data: function () {
    return {
      isFocused: null,
      isInvisible: true
    }
  },
  components: {
    LandingBody,
    NavFooter,
    PrivacyPage,
    TermsPage,
    CookieLaw
  },
  methods: {
    onLoadBackgroundImage () {
      this.isInvisible = false
    }
  },
  created () {
    bus.$on('overlayOpacityChanged', (data) => {
      this.isFocused = data
    })
  },
  destroyed () {
    bus.$off('overlayOpacityChanged', (data) => {
      this.isFocused = data
    })
  },
  computed: {
    backgroundImage () {
      return require('../assets/img/background_bike.jpg')
    },
    backgroundImagePreview () {
      return require('../assets/img/background_bike_preview.jpg')
    }
  }
}
</script>

<style scoped>
  #particles-js {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    z-index: 1;
    background: rgba(0,0,0,0) center center/cover;
  }

  /*#landing-page {
    background: #19B49B url(../assets/img/background_bike.jpg) center center/cover no-repeat;
    position: relative;
  }*/

  .is-overlay.is-landing {
    background-color: #090A0D;  /* #4682b4; #23272F;*/
    opacity: .3;
  }
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue